<template>
  <div class="summaryLastGame">
    <div class="summaryLastGame__headerwhite">Último partido</div>
    <div class="summaryLastGame__header">
      <div class="summaryLastGame__header__title">
        <div class="summaryLastGame__header__title__matchday" v-if="game && Object.keys(game).length > 0">
          {{ matchDayName }}
        </div>
        <div class="summaryLastGame__header__title__game">
          <div class="summaryLastGame__header__title__game__team">
            <img
              v-if="game && Object.keys(game).length > 0"
              :src="`https://golstatsimages.blob.core.windows.net/teams-80/${game.home_team}.png`"
            />
          </div>
          <div class="summaryLastGame__header__title__game__score" v-if="game && Object.keys(game).length > 0">
            {{ game.score[0] }}-{{ game.score[1] }}
          </div>
          <div class="summaryLastGame__header__title__game__team">
            <img
              v-if="game && Object.keys(game).length > 0"
              :src="`https://golstatsimages.blob.core.windows.net/teams-80/${game.visiting_team}.png`"
            />
          </div>
        </div>
      </div>
      <div class="summaryLastGame__header__subtitle" v-if="game && Object.keys(game).length > 0">
        {{
          new Date(game.date_time_utc)
            .toLocaleDateString('es-ES', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
            })
            .replace(',', '')[0]
            .toUpperCase() +
            new Date(game.date_time_utc)
              .toLocaleDateString('es-ES', {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
              })
              .replace(',', '')
              .substring(1)
        }}
      </div>
    </div>
    <div class="summaryLastGame__table">
      <div class="summaryLastGame__table__lefttable">
        <div class="summaryLastGame__table__lefttable__row">
          <template v-if="type == 1">
            <div class="summaryLastGame__table__lefttable__row__title">Titular:</div>
            <div class="summaryLastGame__table__lefttable__row__val">
              {{ match['isTitular'] == 1 ? 'Si' : 'No' }}
            </div>
          </template>
          <template v-else>
            <div class="summaryLastGame__table__lefttable__row__title">Resultado:</div>
            <div class="summaryLastGame__table__lefttable__row__val">
              {{ match['result'] == 1 ? 'Ganado' : match['result'] == 2 ? 'Perdido' : 'Empatado' }}
            </div>
          </template>
        </div>
        <div class="summaryLastGame__table__lefttable__sep"></div>
        <div class="summaryLastGame__table__lefttable__row">
          <template v-if="type == 1">
            <div class="summaryLastGame__table__lefttable__row__title">Minutos jugados:</div>
            <div class="summaryLastGame__table__lefttable__row__val">{{ match['minutes'] }}</div>
          </template>
          <template v-else>
            <div class="summaryLastGame__table__lefttable__row__title">xG:</div>
            <div class="summaryLastGame__table__lefttable__row__val" v-if="match['xg']">
              {{ match['xg'].toFixed(2) }}
            </div>
          </template>
        </div>
        <template v-if="type == 2">
          <template v-for="(item, index) in match['extra_categories']">
            <template v-if="index < 2">
              <div :key="index + 'psep1'" class="summaryLastGame__table__lefttable__sep"></div>
              <div :key="index + 'pfat1'" class="summaryLastGame__table__lefttable__row">
                <div class="summaryLastGame__table__lefttable__row__title">{{ item.category_name }}</div>
                <div class="summaryLastGame__table__lefttable__row__val">{{ item.total }}</div>
              </div>
            </template>
          </template>
        </template>
        <div class="summaryLastGame__table__lefttable__sep" v-if="type == 1"></div>
        <div class="summaryLastGame__table__lefttable__row" v-if="type == 1">
          <template v-if="position != 1">
            <div class="summaryLastGame__table__lefttable__row__title">Goles:</div>
            <div class="summaryLastGame__table__lefttable__row__val">{{ match['goals'] }}</div>
          </template>
          <template v-else>
            <div class="summaryLastGame__table__lefttable__row__title">Tarjetas amarillas:</div>
            <div class="summaryLastGame__table__lefttable__row__val">{{ match['yellowcards'] }}</div>
          </template>
        </div>
        <div class="summaryLastGame__table__lefttable__sep" v-if="type == 1"></div>
        <div class="summaryLastGame__table__lefttable__row" v-if="type == 1">
          <template v-if="position != 1">
            <div class="summaryLastGame__table__lefttable__row__title">Tarjetas amarillas:</div>
            <div class="summaryLastGame__table__lefttable__row__val">{{ match['yellowcards'] }}</div>
          </template>
          <template v-else>
            <div class="summaryLastGame__table__lefttable__row__title">Tarjetas rojas:</div>
            <div class="summaryLastGame__table__lefttable__row__val">{{ match['redcards'] }}</div>
          </template>
        </div>
      </div>
      <div class="summaryLastGame__table__righttable" v-if="match['extra_categories']">
        <div class="summaryLastGame__table__righttable__sep flag-movil" v-if="type == 1"></div>
        <div class="summaryLastGame__table__righttable__row" v-if="type == 1 && position != 1">
          <div class="summaryLastGame__table__righttable__row__title">Tarjetas rojas:</div>
          <div class="summaryLastGame__table__righttable__row__val">{{ match['redcards'] }}</div>
        </div>
        <template v-if="type == 2">
          <template v-for="(item, index) in match['extra_categories']">
            <template v-if="index >= 2">
              <div
                :key="index + 'lsr'"
                class="summaryLastGame__table__righttable__sep "
                :class="index == 2 ? 'flag-movil' : ''"
              ></div>
              <div :key="index + 'dvid'" class="summaryLastGame__table__righttable__row">
                <div class="summaryLastGame__table__righttable__row__title">{{ item.category_name }}:</div>
                <div class="summaryLastGame__table__righttable__row__val">
                  <template v-if="item.category_name == 'xG '">{{ item.total.toFixed(2) }}</template
                  ><template v-else>{{ item.total }}</template>
                </div>
              </div>
            </template>
          </template>
        </template>
        <template v-else>
          <template v-for="(item, index) in match['extra_categories']">
            <div
              :key="index + 'lsr'"
              class="summaryLastGame__table__righttable__sep"
              :class="type == 1 && position == 1 && index == 0 ? 'flag-movil' : ''"
            ></div>
            <div :key="index + 'lsr - r'" class="summaryLastGame__table__righttable__row">
              <div class="summaryLastGame__table__righttable__row__title">{{ item.category_name }}:</div>
              <div class="summaryLastGame__table__righttable__row__val">
                <template v-if="item.category_name == 'xG '">{{ item.total.toFixed(2) }}</template
                ><template v-else>{{ item.total }}</template>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { regularLeague, cup, cupLegacy } from '@/utils/play-off-abbreviations';

export default {
  name: 'SummaryLastGame',
  components: {},
  data() {
    return {};
  },
  watch: {},
  props: {
    match: {
      type: [Object, Array, Number],
      default: () => [],
    },
    game: {},
    position: {
      type: Number,
      default: 1,
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapGetters('filterGeneral', {
      seasonId: 'getSeasonId',
      isCup: 'isCup',
    }),
    matchDayName() {
      let matchDayName = '';
      const roundNumberString = this.game.matchday_abbreviation.replace('M', '');
      const defaultName = `Jornada ${roundNumberString}`;
      if (this.isCup) {
        if (this.seasonId === 881) {
          matchDayName = cupLegacy[roundNumberString] || defaultName;
        } else {
          matchDayName = cup[this.game.matchday_abbreviation] || defaultName;
        }
      } else {
        if (this.game.season && this.game.season.type === 2) {
          if (this.game.matchday_id === 182) {
            matchDayName = 'PI1';
          } else if (this.game.matchday_id === 183) {
            matchDayName = 'PI2';
          } else if (this.game.matchday_id === 18) {
            matchDayName = 'Repechaje';
          }
        } else {
          matchDayName = regularLeague[this.game.matchday_abbreviation] || defaultName;
        }
      }
      return matchDayName;
    },
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.flag-movil {
  display: none;
  @media screen and (max-width: 500px) {
    display: inline-block;
  }
}
.summaryLastGame {
  width: 100%;
  height: auto;
  // background: purple;
  display: inline-block;
  &__headerwhite {
    width: 100%;
    height: 2.632vw;
    display: inline-block;
    background-color: white;
    color: white;
    border-radius: 8px;
    font-family: 'Roboto-Black';
    border: solid 2px #e7eaed;
    font-size: 1.368vw;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.632vw;
    letter-spacing: -0.26px;
    text-align: center;
    color: #132839;
    @media screen and (max-width: 1120px) {
      height: 4.658vw;
      font-size: 2.268vw;
      line-height: 4.658vw;
    }
    @media screen and (max-width: 768px) {
      height: 7vw;
      font-size: 3.214vw;
      line-height: 7vw;
    }
    @media screen and (max-width: 500px) {
      height: 10.458vw;
      font-size: 4.714vw;
      line-height: 10.458vw;
    }
  }
  &__header {
    width: 100%;
    height: 3.158vw;
    border-radius: 4.8px;
    margin-top: 0.526vw;
    display: inline-flex;

    justify-content: space-between;
    background-color: #132839;
    color: white;
    @media screen and (max-width: 1120px) {
      height: 5.658vw;
    }
    @media screen and (max-width: 768px) {
      height: 7.958vw;
    }
    @media screen and (max-width: 500px) {
      height: 27.958vw;
      display: inline-block;
    }
    &__title {
      display: inline-flex;
      @media screen and (max-width: 500px) {
        display: inline-block;
      }
      &__matchday {
        font-family: 'Roboto-Black';
        font-size: 1.368vw;
        font-weight: bold;
        font-stretch: normal;
        padding-left: 2.105vw;
        font-style: normal;
        line-height: 3.158vw;
        letter-spacing: -0.26px;
        text-align: center;
        color: #cbee6b;
        @media screen and (max-width: 1120px) {
          line-height: 5.658vw;
          font-size: 1.968vw;
        }
        @media screen and (max-width: 768px) {
          line-height: 7.958vw;
          font-size: 3vw;
        }
        @media screen and (max-width: 500px) {
          line-height: 8.958vw;
          font-size: 5.258vw;
          padding-left: 0vw;
        }
        &__num {
          padding-left: 0.474vw;
          @media screen and (max-width: 500px) {
            padding-left: 0.974vw;
          }
        }
      }
      &__game {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        padding-left: 2.105vw;
        height: 3.158vw;
        @media screen and (max-width: 1120px) {
          height: 5.658vw;
          padding-left: 5.105vw;
        }
        @media screen and (max-width: 768px) {
          height: 7.958vw;
          padding-left: 5.105vw;
        }
        @media screen and (max-width: 500px) {
          padding-left: 0vw;
        }
        &__team {
          width: 1.905vw;
          @media screen and (max-width: 1120px) {
            width: 2.605vw;
          }
          @media screen and (max-width: 768px) {
            width: 3.605vw;
          }
          @media screen and (max-width: 500px) {
            width: 6.905vw;
          }
        }
        &__score {
          width: 3.405vw;
          font-family: 'Roboto-Black';
          font-size: 1.211vw;
          font-weight: 900;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.96vw;
          letter-spacing: -0.23px;
          text-align: center;
          color: #cbee6b;
          @media screen and (max-width: 1120px) {
            width: 5.405vw;
            font-size: 1.968vw;
          }
          @media screen and (max-width: 768px) {
            width: 6.405vw;
            font-size: 2.568vw;
          }
          @media screen and (max-width: 500px) {
            width: 13.905vw;
            font-size: 4.568vw;
          }
        }
      }
    }
    &__subtitle {
      font-family: 'Roboto-Regular';
      text-transform: capitalize;
      font-size: 1vw;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 3.158vw;
      letter-spacing: -0.19px;
      text-align: center;
      color: #cbee6b;
      padding-right: 2.105vw;
      @media screen and (max-width: 1120px) {
        line-height: 5.658vw;
        font-size: 1.968vw;
      }
      @media screen and (max-width: 768px) {
        line-height: 7.958vw;
        font-size: 3vw;
      }
      @media screen and (max-width: 500px) {
        line-height: 9.958vw;
        font-size: 3.547vw;
      }
      &__bold {
        font-family: 'Roboto-Black';
        padding-left: 1vw;
        font-weight: bold;
      }
    }
  }
  &__table {
    width: 100%;
    height: auto;
    border-radius: 9.6px;
    border: solid 0.5px #c4c7cb;
    background-color: #fff;
    margin-top: 0.526vw;
    display: inline-flex;
    @media screen and (max-width: 500px) {
      display: inline-block;
      margin-top: 1.926vw;
    }
    &__lefttable {
      width: 50%;
      // background: blue;
      margin-left: 1.053vw;
      margin-right: 1.368vw;
      margin-top: 0.947vw;
      margin-bottom: 0.947vw;
      @media screen and (max-width: 500px) {
        margin-top: 3.87vw;
        margin-bottom: 2vw;
        width: 100%;
        margin-left: 0vw;
        margin-right: 0vw;
      }
      @media screen and (max-width: 380px) {
        margin-top: 6vw;
        margin-bottom: 3vw;
        width: 100%;
        margin-left: 0vw;
        margin-right: 0vw;
      }
      &__sep {
        width: 100%;
        height: 1px;
        border-bottom: 1px dotted #a2aab7;
        margin-top: 0.5vw;
        margin-bottom: 0.5vw;
        @media screen and (max-width: 500px) {
          width: 90%;
          margin: 0 auto;
          margin-top: 0.5vw;
          margin-bottom: 0.5vw;
          display: inline-block;
        }
      }
      &__row {
        width: 100%;
        height: 2.421vw;
        display: inline-flex;
        justify-content: space-between;
        @media screen and (max-width: 1120px) {
          height: 5.658vw;
        }
        @media screen and (max-width: 768px) {
          height: 9vw;
        }
        @media screen and (max-width: 500px) {
          display: inline-block;
          height: 12vw;
        }
        &__title {
          line-height: 2.421vw;
          font-family: 'Roboto-Regular';
          font-size: 0.958vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.22px;
          text-align: left;
          color: #727a80;
          padding-left: 0.526vw;
          @media screen and (max-width: 1120px) {
            font-size: 1.758vw;
            line-height: 5.658vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.558vw;
            line-height: 9vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 4.258vw;
            line-height: 5vw;
            text-align: center;
          }
          @media screen and (max-width: 380px) {
            font-size: 4.758vw;
            line-height: 8vw;
            text-align: center;
          }
        }
        &__val {
          line-height: 2.421vw;
          font-family: 'Roboto-Black';
          font-size: 0.958vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.22px;
          text-align: left;
          color: #132839;
          padding-right: 0.526vw;
          @media screen and (max-width: 1120px) {
            font-size: 1.758vw;
            line-height: 5.658vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.558vw;
            line-height: 9vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 4.958vw;
            line-height: 7.8vw;
            text-align: center;
          }
          @media screen and (max-width: 380px) {
            font-size: 5.958vw;
            line-height: 8vw;
            text-align: center;
          }
          &__gray {
            font-family: 'Roboto-Regular';
            color: #727a80;
          }
        }
      }
    }
    &__righttable {
      width: 50%;
      // background: goldenrod;
      margin-left: 1.053vw;
      margin-right: 1.368vw;
      margin-top: 0.947vw;
      margin-bottom: 0.947vw;
      @media screen and (max-width: 500px) {
        margin-top: -0.98vw;
        margin-bottom: 4vw;
        width: 100%;
        margin-left: 0vw;
        margin-right: 0vw;
      }
      @media screen and (max-width: 380px) {
        margin-top: 3vw;
        margin-bottom: 6vw;
        width: 100%;
        margin-left: 0vw;
        margin-right: 0vw;
      }
      &__sep {
        width: 100%;
        height: 1px;
        border-bottom: 1px dotted #a2aab7;
        margin-top: 0.5vw;
        margin-bottom: 0.5vw;
        @media screen and (max-width: 500px) {
          width: 90%;
          margin: 0 auto;
          margin-top: 0.5vw;
          margin-bottom: 0.5vw;
          display: inline-block;
        }
      }
      &__row {
        width: 100%;
        height: 2.421vw;
        display: inline-flex;
        justify-content: space-between;
        @media screen and (max-width: 1120px) {
          height: 5.658vw;
        }
        @media screen and (max-width: 768px) {
          height: 9vw;
        }
        @media screen and (max-width: 500px) {
          height: 12vw;
          display: inline-block;
        }
        &__title {
          line-height: 2.421vw;
          font-family: 'Roboto-Regular';
          font-size: 0.958vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.22px;
          text-align: left;
          color: #727a80;
          padding-left: 0.526vw;
          @media screen and (max-width: 1120px) {
            font-size: 1.758vw;
            line-height: 5.658vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.558vw;
            line-height: 9vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 4.258vw;
            line-height: 5vw;
            text-align: center;
          }
          @media screen and (max-width: 380px) {
            font-size: 4.758vw;
            line-height: 8vw;
            text-align: center;
          }
        }
        &__val {
          line-height: 2.421vw;
          font-family: 'Roboto-Black';
          font-size: 0.958vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.22px;
          text-align: left;
          color: #132839;
          padding-right: 0.526vw;
          @media screen and (max-width: 1120px) {
            font-size: 1.758vw;
            line-height: 5.658vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.758vw;
            line-height: 9vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 4.958vw;
            line-height: 7.8vw;
            text-align: center;
          }
          @media screen and (max-width: 380px) {
            font-size: 5.958vw;
            line-height: 8vw;
            text-align: center;
          }
          &__gray {
            font-family: 'Roboto-Regular';
            color: #727a80;
          }
        }
      }
    }
  }
}
</style>
